import kamala from '../../kamala'
import DatePicker from './Picker'

DatePicker.install = function (Vue) {
  kamala(Vue)
  Vue.component(DatePicker.name, DatePicker)
}

export default DatePicker
